<template>
  <div class="api-keys">
    <h1>Accident Plan API Keys</h1>
    <template v-if="orgStatus === 'loading'">
      Loading...
    </template>
    <template v-if="orgStatus === 'fetched'">
      <div v-for="org in orgs" :key="org.id">
        <OrgKey v-bind="org" />
      </div>
    </template>
    <template v-if="orgStatus === 'failed'">
      <p v-if="error" class="error">
        {{ error }}
      </p>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import OrgKey from './OrgKey';

export default {
  name: 'ApiKeys',
  hagridActions: [
    'Orgs/fetch',
  ],
  computed: {
    ...mapState({
      orgs: state => state.Orgs.orgs,
      orgStatus: state => state.Orgs.status,
      error: state => state.Orgs.error,
    }),
  },
  components: {
    OrgKey,
  },
};
</script>

<style>
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/ApiKeys.vue